
export default class Messages {
    initialize() {
        if ($('.messages-page').length) {

            this.scrollMessages();
            this.refreshChat();

            this.liveWire();
        }
    }

    liveWire() {
        Livewire.on('immediateScrollMessages', event => {
            this.immediateScrollMessages();
        });
    }

    refreshChat() {
        var context = this;

        // refresh chat messages every 10 seconds
		setInterval(function () {
            Livewire.emit('refreshChat');

            context.immediateScrollMessages();
		}, 10000);
    }

    immediateScrollMessages() {
        $('.messages').scrollTop($('.messages')[0].scrollHeight);
    }

    scrollMessages() {
        setTimeout(function() {
            $('.messages').scrollTop($('.messages')[0].scrollHeight);
        }, 200);
    }
}